import type {
  TierIIStateReporting,
  TierIISupplementalFacilityAnswers,
  TierIISupplementalStateAnswers,
} from '../../tri-shared/types/tierii-state-fields.ts';

export function emptySupplementalFacilityAnswers(): TierIISupplementalFacilityAnswers {
  return {
    stateFacilityId: null,
    parentCompanyPhone: null,
    ownerOperatorPhone24: null,
    mailingCountry: null,
  };
}
export function emptySupplementalStateAnswers(): TierIISupplementalStateAnswers {
  return { facility: emptySupplementalFacilityAnswers(), chemicals: {} };
}
/** An absent state has no recorded answers; every answer within a recorded state has an explicit value. */
export function supplementalFacilityAnswers(
  reporting: TierIIStateReporting,
  state: string,
): TierIISupplementalFacilityAnswers {
  return reporting.supplemental[state]?.facility ?? emptySupplementalFacilityAnswers();
}
export function supplementalStateAnswersEnsure(
  reporting: TierIIStateReporting,
  state: string,
): TierIISupplementalStateAnswers {
  return (reporting.supplemental[state] ??= emptySupplementalStateAnswers());
}
export function supplementalBelowThresholdSet(
  reporting: TierIIStateReporting,
  state: string,
  entryKey: string,
  value: boolean,
): void {
  supplementalStateAnswersEnsure(reporting, state).chemicals[entryKey] = { belowReportingThresholds: value };
}
